export default {
  form: {
    amount: {
      label: 'Preço',
    },
    has_sales_based_discount: {
      label: 'Descontos baseados nas vendas mensais',
    },
  },
  labels: {
    month: 'mês',
    varies_by_tier: 'varia por escalão',
    max_price: '* O preço máximo é {{amount}}',
    sales_based_discount:
      'até +{{threshold}} de vendas mínimas num mês. Após isso, preço regular {{amount}} líquido/mês',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (incluído)',
    exclusive: 'por mês mais {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Selecionar',
    save: 'Guardar',
    use_default_price: 'Usar preço padrão',
  },
};
